import React from 'react';
import PropTypes from 'prop-types';
import Hr from './Hr';
import './styles/footer.scss';

const InnerFooter = ({ shopName }) => (
  <div>
    <Hr />

    <div className="c-vi-inner-footer-container">
      <div className="c-vi-inner-footer-column left">
        {"You're"} receiving this email because you use Squire to manage your appointments for {shopName}.
      </div>

      <div className="c-vi-inner-footer-column right">
        <a href="https://www.instagram.com/getsquire/" target="_blank" rel="noopener noreferrer">
          <img src="https://assets.getsquire.com/widget-release-email/instagram.png" alt="IG" role="presentation" />
          Instagram
        </a>
      </div>
    </div>
  </div>
);

InnerFooter.propTypes = {
  shopName: PropTypes.string.isRequired,
};

export default InnerFooter;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/visualIdentity/InnerFooter.jsx